<template>
  <div class="site-footer">
    <div class="site-footer__top">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-4">
            <div>
              <a href="https://www.balfour.com/">
                <img
                  :src="pngBalfourLogoWhite"
                  class="site-footer__brand-logo"
                >
              </a>
            </div>
            <div class="site-footer__guarantee-msg">
              100% Satisfaction Guaranteed
            </div>
            <div>
              <div class="site-footer__social-links">
                <a
                  v-for="(socialLink, socialLinkIndex) in socialLinks"
                  :key="socialLinkIndex"
                  :href="socialLink.url"
                  class="site-footer__social-link"
                  target="_blank"
                  @click="handleLinkClick(socialLink)"
                >
                  <img :src="socialLink.logoImg">
                </a>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4">
            <a
              v-for="(infoLink, infoLinkIndex) in infoLinks"
              :key="infoLinkIndex"
              :href="infoLink.url"
              :title="infoLink.name"
              class="site-footer__info-link"
              target="_blank"
              @click="handleLinkClick(infoLink)"
            >
              {{ infoLink.name }}
            </a>
          </div>
          <div class="col-xs-12 col-sm-4">
            <div class="site-footer__legal-links">
              <div
                v-for="(legalLink, legalLinkIndex) in legalLinks"
                :key="legalLinkIndex"
              >
                <a
                  :href="legalLink.url"
                  :title="legalLink.name"
                  class="site-footer__legal-link"
                  target="_blank"
                  @click="handleLinkClick(legalLink)"
                >
                  {{ legalLink.name }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="site-footer__bottom">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="site-footer__copyright-notice">
              &copy; {{ currentYear }} American Achievement Corp.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pngFacebookLogo from '../assets/facebook-logo.png'
import pngInstagramLogo from '../assets/instagram-logo.png'
import pngBalfourLogoWhite from '../assets/balfour-celebratingu-white@2x.png'
import ResponsiveBreakpointsMixin from '@Shared/mixins/responsive-breakpoints'

export default {
  name: 'SiteFooter',
  mixins: [ResponsiveBreakpointsMixin],
  data () {
    return {
      pngBalfourLogoWhite,
      socialLinks: [
        {
          name: 'Facebook',
          url: 'https://www.facebook.com/Balfourconnect/',
          logoImg: pngFacebookLogo
        },
        {
          name: 'Instagram',
          url: 'https://www.instagram.com/balfourconnect/',
          logoImg: pngInstagramLogo
        }
      ],
      infoLinks: [
        {
          name: 'Jacket Anatomy',
          url: 'http://www.balfourletterjacket.com/jacket-anatomy'
        },
        {
          name: 'Brochure',
          url: 'https://issuu.com/balfour/docs/sy23-letterjacket-bro_issuu?fr=sMjdhOTQ1MzUyNzU'
        },
        {
          name: 'About',
          url: 'http://www.balfourletterjacket.com/about'
        },
        {
          name: 'FAQs',
          url: 'http://www.balfourletterjacket.com/faq'
        }
      ],
      legalLinks: [
        {
          name: 'CCPA',
          url: 'https://www.balfour.com/HelpCenter/Legal/CCPA%20Privacy%20Notice'
        },
        {
          name: 'Do Not Sell My Information',
          url: 'https://www.balfour.com/HelpCenter/Legal/Do%20Not%20Sell%20My%20Information'
        },
        {
          name: 'Privacy',
          url: 'https://www.balfour.com/HelpCenter/Legal/Privacy%20Security'
        },
        {
          name: 'Terms of Use',
          url: 'https://www.balfour.com/HelpCenter/Legal/Terms%20of%20Use'
        }
      ]
    }
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  },
  methods: {
    handleLinkClick (linkObject) {
      if (linkObject.url === '#') {
        window.alert('Not yet implemented')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.site-footer {
  &__top {
    background-color: #222a2e;
    color: #fff;
    padding: 20px 0;
  }

  &__brand-logo {
    width: 150px;
    display: block;
    margin: 0 auto 20px auto;
  }

  &__guarantee-msg {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
    text-align: center;
    text-transform: uppercase;
  }

  &__social {
    &-links {
      text-align: center;
    }

    &-link {
      display: inline-block;
    }
  }

  &__info-link,
  &__legal-link {
    color: #fff;
    display: block;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
    text-align: center;
    text-transform: uppercase;
    text-decoration: underline;
  }

  &__bottom {
    padding: 10px 0;
    background-color: #000;
    color: #fff;
    font-size: 14px;
  }

  &__copyright-notice {
    font-size: 14px;
    text-align: center;
  }

  @media screen and (min-width: $screen-sm-min) {
    &__top {
      padding: 40px 0;
    }

    &__bottom {
      background-color: #000;
      color: #fff;
      font-size: 14px;

      &-links {
        color: #fff;
      }

      &-link {
        display: inline;
        margin-bottom: 0;
        padding: 0 20px;
      }
    }

    &__copyright-notice {
      text-align: center;
    }
  }
}

.footer__site-links {
  margin-bottom: 40px;

  &--social {
    text-align: center;
  }

  @media screen and (min-width: $screen-lg-min) {
    margin-bottom: 20px;

    &--social {
      text-align: right;
    }
  }
}

.footer__site-link {
  font-weight: normal;

  &--social {
    display: inline-block;
    margin: 0 10px;
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/site-footer/components/SiteFooter.vue